
/* injects from baggage-loader */

CKEDITOR.plugins.add('variable', {
  init: function (editor) {
    const command = editor.addCommand('jcContactFields', new CKEDITOR.dialogCommand('jcContactFields'));
    command.modes = {wysiwyg: 1, source: 0};
    command.canUndo = true;

    editor.ui.addButton('ContactFields', {
      label: '{...}',
      className: 'cke_format',
      command: 'jcContactFields',
    });

    CKEDITOR.dialog.add('jcContactFields', function (editor) {
      return {
        title: editor.lang.variable.title,
        minWidth: 400,
        minHeight: 150,
        onLoad: function () {
          const onChoice = function (evt) {
            let target;

            if (evt.data) {
              target = evt.data.getTarget();
            } else {
              target = new CKEDITOR.dom.element(evt);
            }

            editor.insertHtml(target.$.dataset.html);
          };

          const search = (evt) => {
            let target;

            if (evt.data) {
              target = evt.data.getTarget();
            } else {
              target = new CKEDITOR.dom.element(evt);
            }

            const value = target.$.value.toLowerCase();
            const container = this.getContentElement('jc-contact-fields', 'jc-contact-fields-container').getElement()
            const fields = container.$.querySelectorAll('.cke_dialog_ui_button')

            fields.forEach(field => {
              if (value.length > 1) {
                const text = field.textContent.toLowerCase()

                if (text.match(new RegExp(value, 'g'))) {
                  if (!field.classList.contains("active")) {
                    field.classList.add("active");
                  }
                } else {
                  if (field.classList.contains("active")) {
                    field.classList.remove("active");
                  }
                }
              } else {
                if (!field.classList.contains("active")) {
                  field.classList.add("active");
                }
              }
            })
          }

          const onClick = CKEDITOR.tools.addFunction(onChoice)
          const onChangeSearch = CKEDITOR.tools.addFunction(search)
          const ckeditorVariables = window.justclick.ckeditorConfig !== undefined ? window.justclick.ckeditorConfig.variables : [];


          let html = [
            `<div class="jc-contact-fields">` +
              `<input class="cke_dialog_ui_input_text" type="text"` +
                `placeholder="${editor.lang.variable.search}" ` +
                `onchange="CKEDITOR.tools.callFunction(${onChangeSearch}, this)"` +
                `onkeyup="CKEDITOR.tools.callFunction(${onChangeSearch}, this)">` +
              `<div class="jc-contact-fields__list">`
          ];

          ckeditorVariables.map(field => {
            html.push(
                `<a class="cke_dialog_ui_button active" ` +
                  `href="javascript: void(0);" ` +
                  `onclick="CKEDITOR.tools.callFunction(${onClick}, this); return false;" ` +
                  `data-html="${field.key}">` +
                  `${field.title}` +
                `</a>`
            )
          })

          html.push('</div></div>')

          this.getContentElement('jc-contact-fields', 'jc-contact-fields-container').getElement().setHtml(html.join(''));
        },
        buttons: [ CKEDITOR.dialog.cancelButton ],
        contents: [{
          id: 'jc-contact-fields',
          elements: [{
            type: 'hbox',
            align: 'top',
            widths: ['320px', '90px'],
            children: [{
              type: 'html',
              id: 'jc-contact-fields-container',
              html: '',
            }]
          }]
        }]
      };
    });
  }
});




// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/variable/plugin.js